import { Component, Input } from '@angular/core';

@Component({
  selector: 'idp-logo-header',
  templateUrl: './logo-header.component.html',
  styleUrls: ['./logo-header.component.scss']
})
export class LogoHeaderComponent {
  @Input() logoUrl: string | undefined = '';
  @Input() altText: string | undefined = '';
}
